import PropTypes from "prop-types";
import * as React from 'react';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import { Typography } from "@mui/material";


export default function Primary(props) {
  // const primaries = getPrimaries();
  const [primaries, setPrimaries] = React.useState([])

  React.useEffect(() => {
    if (props.categoryMap && props.categoryMap.primaries) {
      setPrimaries(Object.keys(props.categoryMap.primaries));
    }
  }, [props.categoryMap]);

  React.useEffect(() => {
    if (primaries.length > 0 && !props.primary) {
      props.handleChange({ target: { value: primaries[0] } });
    }
  }, [primaries, props.primary]);  

  return (
    <div>
      <Typography variant="subtitle1" sx={{ mt: '1rem', ml: '5px', mb: '1rem' }}>Welche Orientierung soll ihr Schullogbuch haben?</Typography>
      <FormControl  sx={{ m: 1, width: '90%' }} fullWidth {...(props.disabled ? { disabled: "disabled" } : {})}>
        <InputLabel id="demo-simple-select-label">Primäre Kategorie</InputLabel>
        <Select
          data-testid="primary-select"
          labelId="demo-simple-select-label"
          id="demo-simple-select"
          value={props.primary}
          label="Primäre Kategorie"
          onChange={props.handleChange}
        >
          {primaries.map((primary) => (
            <MenuItem key={primary} value={primary} data-testid={`primary-option-${primary}`}>
              {primary}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </div>
  );
}

Primary.propTypes = {
    primary: PropTypes.string.isRequired,
    categoryMap: PropTypes.object.isRequired,
    handleChange: PropTypes.func,
    disabled: PropTypes.bool,
};